import {
  catchError,
  from,
  mergeMap,
  Observable,
  of,
  scan,
  switchMap,
} from 'rxjs';

const buildOffsets = (total: number, size: number): number[] => {
  const offsets: number[] = [];

  if (size <= 0) {
    return [];
  }

  for (let i = 0; i < total; i += size) {
    offsets.push(i);
  }

  return offsets;
};

export function fetchPaginatedData<T>(
  countObservable: Observable<{ count: number }>,
  fetchChunkFunction: (pageSize: number, offset: number) => Observable<T[]>,
  pageSize: number,
  concurrency: number
): Observable<T[]> {
  return countObservable.pipe(
    switchMap(({ count }) => {
      if (!count) {
        return of([] as T[]);
      }

      const offsets = buildOffsets(count, pageSize);

      return from(offsets).pipe(
        mergeMap(
          (offset) =>
            fetchChunkFunction(pageSize, offset).pipe(
              catchError((error) => {
                console.error('Chunk failed at offset:', offset, error);
                return of([] as T[]);
              })
            ),
          concurrency
        ),
        scan((accumulate, chunk) => accumulate.concat(chunk), [] as T[])
      );
    })
  );
}
